import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const englishOrgData = {
  nameTitle: 'Workspace name',
  namePlaceholder: 'Name',
  avatarTitle: 'Workspace logo',
  avatarPlaceholder: 'Upload your workspace logo',
  primaryColorTitle: 'Workspace primary color',
  primaryColorPlaceholder: '#011E1E',
  secondaryColorTitle: 'Workspace secondary color',
  secondaryColorPlaceholder: '#B8EF36',
  description: 'Description',
  desscriptionPlaceholder: 'Description for your workspace',
  cancel: 'Cancel',
  type: 'Workspace type',
  selectType: 'Select workspace type',
  selectLLMProvider: 'Select LLM provider:',
  llmProviderPlaceholder: 'LLM provider',
  learnerAppSettings: 'Learner app settings',
  courseIconsTitle: 'Display course icons in learner app',
  courseIconsSubtitle:
    'Show course icons at the top of the microreel feed for learners.',
  courseIconsHint: 'Turning this off hides the course icons.',
  reset: 'Reset',
};

const welshOrgData = {
  nameTitle: 'Enw gweithle',
  namePlaceholder: 'Enw',
  avatarTitle: 'Logo gweithle',
  avatarPlaceholder: 'Llwythwch i fyny eich logo Gweithle',
  primaryColorTitle: 'Lliw cynradd gweithle',
  secondaryColorTitle: 'Lliw eilaidd gweithle',
  description: 'Disgrifiad',
  desscriptionPlaceholder: "Disgrifiad o'ch gweithle",
  cancel: 'Canslo',
  type: 'Math o le gwaith',
  learnerAppSettings: 'Gosodiadau ap y dysgwr',
  courseIconsTitle: 'Dangos eiconau cyrsiau yn ap y dysgwr',
  courseIconsSubtitle:
    'Dangos eiconau cyrsiau ar frig y ffrwd microreel i ddysgwyr.',
  courseIconsHint: "Bydd diffodd hwn yn cuddio'r eiconau cyrsiau.",
  selectType: 'Dewiswch y math o weithle',
  reset: 'Ailosod',
};

export const orgDataFormText: any = getLocalizationBasedOnLang(
  englishOrgData,
  welshOrgData,
);
